module.exports = __webpack_public_path__ + "static/fx_9.71fe6d83.jpg";